import { isFeatureEnabled } from '@lumapps/features';
import { isUserAllowed } from '@lumapps/permissions';

const isMediaAllowed = isUserAllowed();
const isAdvancedPickerEnabled = isFeatureEnabled('advanced_picker');

export { isMediaAllowed, isAdvancedPickerEnabled };
